import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import Select from 'components/Form/Select';
import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	reason: Yup.string().required('Champ requis'),
});

const ValidationPausedReasonModal = ({ reasons, open, close, submit }) => {
	return (
		<Modal
			size='small'
			open={open}
			closeOnEscape
			closeOnDimmerClick
			onClose={close}
		>
			<Modal.Header>Motif de la mise en pause</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					reason: '',
				}}
				validationSchema={schemaValidation}
				onSubmit={(values) => {
					submit(values.reason);
					close();
				}}
			>
				{({ submitForm }) => (
					<>
						<Modal.Content>
							Veuillez sélectionner un motif de mise en pause
							<Form>
								<Field
									component={Select}
									name='reason'
									customlabel='Motif'
									placeholder='Sélectionner un motif'
									options={reasons?.map((reason) => ({
										value: reason.label,
										label: reason.label,
									}))}
									required
									isCreatable
								/>
							</Form>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
								
							>
								Annuler
							</Button>
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submitForm();
								}}
							>
								Confirmer
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default ValidationPausedReasonModal;
